var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.72c-7.333 0-13.333 5.987-13.333 13.36 0 6.667 4.88 12.2 11.253 13.2v-9.333h-3.387V16.08h3.387v-2.947c0-3.346 1.987-5.186 5.04-5.186 1.453 0 2.973.253 2.973.253v3.293h-1.68c-1.653 0-2.173 1.027-2.173 2.08v2.507h3.707l-.6 3.867H18.08v9.333a13.333 13.333 0 0 0 11.253-13.2c0-7.373-6-13.36-13.333-13.36Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;